import React, { useState, useEffect } from "react";
import {
    Grid,
    Checkbox,
    TextareaAutosize,
    Typography,
    Button,
    List,
    ListItem
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";

// import MobileScreen from './Mobile/Enter-RailRoad-Add';
// import {isMobile} from 'react-device-detect';

/** Local party dependencies & Libraries */
import Services from '../../../Services';

import Snackbar from '../../../Components/Snackbar';

import { helpers } from "../../../helpers";
import { paths } from "../Application/path";
import SidebarApplicants from "../../../Components/SidebarApplicants";


const {
    users,
    hr,
    Storage,
} = Services;

const {
    showSnackBar,
} = helpers;

const DocumentsStep4 = (props) => {


    const history = useHistory();
    const storage = new Storage();
    const [formsPosted, setFormsPosted] = useState(false);
    var step4FormPosted = new BroadcastChannel('step4form_posted');
    const [formsInfo, setFormsInfo] = useState([])


    step4FormPosted.onmessage = ($e) => {
        const { data = {} } = $e;

        const { topic, message } = data;

        switch (topic) {
            case 'form-updated':
                toggleFormsPosted();
                break;
            default:
                break;
        }
    }

    const toggleFormsPosted = () => {
        setFormsPosted(true);
        setTimeout(setFormsPosted.bind(null, false), 0);
        showSnackBar('Form posted');
    }

    const fetchFilledForms = async (user) => {
        const { data } = await hr.getAllApplicantsByIDApplicantLogin({ id: user?.id }, { Authorization: localStorage.getItem("access_jwt") })
        setFormsInfo(data?.form?.rows?.map(form => form?.ApplicantFormId))
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        let user = JSON.parse(localStorage.getItem('user_profile'));
        if (user) {
            var { ApplicantStatusId } = user;
             
            if (props.status !== ApplicantStatusId)
                history.push({
                    pathname: paths[ApplicantStatusId],
                    state: {
                        approved: false,
                        step: 1,
                        applyToStorage: {
                            user_profile: {
                                ...user,
                                EmployeeStatusId: 9,
                            }
                        }
                    }
                });
        }
        fetchFilledForms(user)

    }, [formsPosted]);

    const saveAndContinue = async () => {
        try {
            const repsonse = await users.submitStep4();
            const user_profile = JSON.parse(storage.get('user_profile'));
            history.push({
                pathname: '/submission/complete',
                state: {
                    approved: false,
                    step: 1,
                    applyToStorage: {
                        user_profile: {
                            ...user_profile,
                            EmployeeStatusId: 9,
                        }
                    }
                }
            });

        } catch (exc) {
             
        }
    }

    return (
        <Grid container xs={12} className="Liq-Container HRPortal">
            <Grid xs={12} md={2} className="LeftContol" id="LeftContol">
                <SidebarApplicants />
            </Grid>
            <Grid xs={12} md={10} container justify="center" className="PageContent">
                <Grid className="PagesFrame">
                    <PageHeader />
                    <Grid id="PageTitle" className="f16">Complete Onboarding Document</Grid>
                    {/* Page Start */}
                    <Grid xs={12} className="ContentPage ApplicantForms">
                        <Grid xs={12} className="StepsLine Step2Line Step4Line">
                            <List>
                                <ListItem className="StepComplete">Step 1</ListItem>
                                <ListItem className="StepComplete">Step 2</ListItem>
                                <ListItem className="StepComplete">Step 3</ListItem>
                                {/* <ListItem className="StepComplete">Step 4</ListItem> */}
                            </List>
                        </Grid>
                        <Grid xs={12}>
                            <Grid xs={12} md={8} lg={6}>
                                <Typography variant="h1" component="h2" className="bold f16">
                                    You're required to fill out the following documents to complete your application
                                </Typography>
                                <Typography variant="h1" component="h2" className="bold f16 mt40">
                                    Section 4
                                </Typography>

                                <Link to="/documents/employee-agreement" target="_blank" className={`DocDownload ${formsInfo?.includes(13) && "disabled-link"}`}>
                                    <Grid className="FileName">
                                        Employment Agreement
                                    </Grid>
                                    <Button className={
                                        formsInfo?.includes(13)
                                            ? ''
                                            : 'graytick'
                                    }
                                    ></Button>
                                </Link>
                                <Link to="/documents/harassment" target="_blank" className={`DocDownload ${formsInfo?.includes(14) && "disabled-link"}`}>
                                    <Grid className="FileName">
                                        TGS Harassment
                                    </Grid>
                                    <Button className={
                                        formsInfo?.includes(14)
                                            ? ''
                                            : 'graytick'
                                    }></Button>
                                </Link>
                                {/* <Link to="/documents/employee-handbook" target="_blank" className="DocDownload">
                                    <Grid className="FileName">
                                        Employee Handbook
                                    </Grid>
                                    <Button className={
                                        formsInfo?.includes(15)
                                            ? ''
                                            : 'graytick'
                                    }></Button>
                                </Link>
                                <Link to="/documents/safety-handbook" target="_blank" className="DocDownload">
                                    <Grid className="FileName">
                                        Safety Handbook
                                    </Grid>
                                    <Button className={
                                        formsInfo?.includes(16)
                                            ? ''
                                            : 'graytick'
                                    }></Button>
                                </Link> */}
                                {/* <Link to="/documents/drug-alcohol-weapons" target="_blank" className="DocDownload">
                                    <Grid className="FileName">
                                        Drug, Alcohol & Weapon
                                    </Grid>
                                    <Button className={
                                      formsInfo?.includes(17)
                                            ? ''
                                            : 'graytick'
                                    }></Button>
                                </Link> */}

                            </Grid>
                            <Snackbar></Snackbar>
                            <Grid xs={12} className="mt50">
                                <Grid xs={12} md={8} lg={6} container justify="space-between">
                                    {/* <Link to="/documents/step/3" className="LinkButtonBack">Back</Link> */}
                                    <Button className="LinkButton" onClick={saveAndContinue}>Save & Continue</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Page Start End */}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default DocumentsStep4;
